//@flow
import type { IconImageAssetType } from "./IconImageAssets";
import { iconImageAssets } from "./IconImageAssets";
export { iconImageAssets };
export type { IconImageAssetType };